import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import NumberUnderPointerDisplay from './number-under-pointer-display';
import {clearCanvas} from '../../services/canvasService';

const CONST = {
    minCanvasWidth: 31,
    dataPointRgbValues: {
        '1': '215,25,28',
        '3': '255,165,0',
        '7': '30,197,8',
        '9': '43,131,186',
        'other': '0,0,0',
    },
};

function resolveColorBasedOnLastDigit(value) {
    const lastDigit = (value % 10).toString(10);

    let rgbValue;
    if (CONST.dataPointRgbValues[lastDigit] !== void(0)) {
        rgbValue = CONST.dataPointRgbValues[lastDigit];
    } else {
        rgbValue = CONST.dataPointRgbValues.other;
    }

    return `rgb(${rgbValue})`;
}

class RowsVisualizationCanvas extends Component {
    constructor(props) {
        super(props);
        this.numbersCanvasRef = React.createRef();
    }

    render() {
        const {width, height} = this.calculateCanvasDimensions();

        return (
            <Fragment>
                <canvas
                    ref={this.numbersCanvasRef}
                    width={width}
                    height={height}
                >
                    This app requires access to the HTML &lt;canvas&gt; element in order to display the visualized data.
                </canvas>
                {this.renderNumberUnderPointer()}
            </Fragment>
        );
    }

    componentDidMount() {
        this.renderDataPoints();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {primeNumbers, numbersPerRow, pixelsPerNumber} = this.props;

        if (primeNumbers !== prevProps.primeNumbers || numbersPerRow !== prevProps.numbersPerRow || pixelsPerNumber !== prevProps.pixelsPerNumber) {
            clearCanvas(this.numbersCanvasRef);
            this.renderDataPoints();
        }
    }

    renderDataPoints = () => {
        const {primeNumbers, numbersPerRow, pixelsPerNumber} = this.props;
        const ctx = this.numbersCanvasRef.current.getContext('2d');

        primeNumbers.forEach((primeNumber) => {
            const x = ((primeNumber - 1) % numbersPerRow) * pixelsPerNumber;
            const y = Math.floor((primeNumber - 1) / numbersPerRow) * pixelsPerNumber;

            ctx.fillStyle = resolveColorBasedOnLastDigit(primeNumber);
            ctx.fillRect(x, y, pixelsPerNumber, pixelsPerNumber);
        });
    };

    renderNumberUnderPointer = () => {
        const {numbersPerRow, pixelsPerNumber} = this.props;
        const {width, height} = this.calculateCanvasDimensions();

        return (
            <NumberUnderPointerDisplay
                numbersPerRow={numbersPerRow}
                pixelsPerNumber={pixelsPerNumber}
                canvasWidth={width}
                canvasHeight={height}
            />
        );
    };

    calculateCanvasDimensions = () => {
        const {primeNumbers, numbersPerRow, pixelsPerNumber} = this.props;
        const numberOfRows = Math.ceil(primeNumbers[primeNumbers.length - 1] / numbersPerRow);

        return {
            width: Math.max(numbersPerRow * pixelsPerNumber, CONST.minCanvasWidth),
            height: pixelsPerNumber * numberOfRows,
        }
    }
}

RowsVisualizationCanvas.propTypes = {
    primeNumbers: PropTypes.arrayOf(PropTypes.number).isRequired,
    numbersPerRow: PropTypes.number.isRequired,
    pixelsPerNumber: PropTypes.number.isRequired,
};

export default RowsVisualizationCanvas;
